import { create } from 'zustand';

export const useTenantMfaSettingsStore = create((set) => ({
    settings: null,
    loading: false,
    error: null,
    setSettings: (settings) => set({ settings }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    reset: () => set({ settings: null, loading: false, error: null }),
}));
